/**
 * Return sort by label for sortType selected
 */
export function getLabelForSortType(options: { label: string; value: string }[], sortType: string): string {
  let result = '';
  for (const option of options) {
    if (option.value === sortType) {
      result = option.label as string;
    }
  }
  return result;
}
